import React, {FC} from 'react'
import {AnimaFadeinTop} from '../../../_metronic/assets/animation/styles'

const SgcWrapper: FC = () => {
  // const intl = useIntl()
  return (
    <>
      <AnimaFadeinTop>
        {/* <Select options={options} /> */}
        <br />
      </AnimaFadeinTop>
    </>
  )
}

export {SgcWrapper}
